<template>
  <div>
    <treeselect
      ref="treeselect"
      id="recipients-treeselect"
      value-format="object"
      :multiple="true"
      :clear-on-select="true"
      :async="true"
      :cache-options="false"
      :load-options="loadOptions"
      :default-options="true"
      :placeholder="placeholder"
      :no-results-text="trans('recipient_search_no_result')"
      v-model="recipients"
      :disabled="disabled"
      @select="onSelect"
    >
      <label slot="option-label" slot-scope="{ node }" v-html="buildOptionHtmlLabel(node.raw)">
      </label>
      <span slot="value-label" slot-scope="{ node }" :title="node.raw.optionLabel" v-b-tooltip>
        {{ node.raw.name || (showEmail ? (node.raw.email || node.raw.mobile) : (node.raw.mobile || node.raw.email)) }}
      </span>
      <div v-if="showAdd" slot="after-list" class="text-right">
        <b-button variant="link"class="pl-0" @click="onClickAdd" >
          <small>
            <i class="fa fa-fw fa-plus"></i>
            {{ trans('add') }}
          </small>
        </b-button>
      </div>
    </treeselect>
    <add-recipient-modal
      v-if="showAdd"
      :organization="organization"
      :initial="query"
      :type="type"
      @added="onAdded"
    ></add-recipient-modal>
  </div>
</template>

<style>
  #recipients-treeselect .vue-treeselect__multi-value-label {
    white-space: normal;
  }
</style>

<script>
  import Treeselect from '@riophae/vue-treeselect'
  import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
  import AddRecipientModal from './AddRecipientModal'

  export default {
    props: {
      organization: Object,
      value: Array, // recipients
      type: String, // email, sms (or mobile) or both
      comtype: String,
      placeholder: {
        type: String,
        default: trans('recipient') + '(s)',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      showAdd: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      Treeselect,
      AddRecipientModal,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        recipients: _.map(this.value || [], this.mapRecipient),
        options: null,
        query: null,
        pending: null, // {query, callback}
        isKeyDown: false,
        keyDownTimerId: null,
      }
    },
    computed: {
      showEmail() {
        return this.type == 'email' || this.type == 'both'
      },
      showMobile() {
        return this.type == 'sms' || this.type == 'mobile' || this.type == 'both'
      },
      serialized() {
        return _.map(this.recipients, r => {
          return _.pick(r, ['name', 'email', 'mobile', 'extra'])
        })
      },
    },
    watch: {
      recipients() {
        this.$emit('input', this.serialized)
      },
      type() {
        this.reload()
      },
    },
    methods: {
      buildOptionHtmlLabel(recipient) {
        let parts = []
        if (recipient.name) parts.push(`<span>${recipient.name}</span>`)
        if (recipient.email) {
          if (this.type == 'email')
            parts.push(`<strong>${recipient.email}</strong>`)
          else
            parts.push(`<span>${recipient.email}</span>`)
        }
        if (recipient.mobile) {
          if (this.type == 'mobile' || this.type == 'sms')
            parts.push(`<strong>${recipient.mobile}</strong>`)
          else
            parts.push(`<span>${recipient.mobile}</span>`)
        }
        return parts.join(', ')
      },
      onAdded(recipient) {
        this.recipients.push(this.mapRecipient(recipient))
        this.$refs.treeselect.closeMenu()
      },
      onSelect() {
        document.querySelector('#recipients-treeselect input.vue-treeselect__input').value = ''
      },
      mapRecipient(r) {
        let id = _.compact([r.name, r.email, r.mobile]).join(' ')
        let label = _.compact([r.name, r.email, r.mobile]).join(' ')
        let optionLabel = r.name
        let extra = []
        if (r.email) extra.push(r.email)
        if (r.mobile) extra.push(r.mobile)
        if (extra.length) {
          if (optionLabel) optionLabel += ` <${extra.join(' ')}>`
          else optionLabel = extra.join(' ')
        }
        return {
          id: id,
          label: label,
          optionLabel: optionLabel,
          name: r.name,
          email: r.email,
          mobile: r.mobile,
          extra: r.extra
        }
      },
      reload() {
        this.$refs.treeselect.getRemoteSearchEntry().isLoaded = false
        this.$refs.treeselect.handleRemoteSearch()
      },
      loadOptions({action, searchQuery, callback}) {
        //console.log('loadOptions', searchQuery)
        if (action == 'ASYNC_SEARCH') {
          if (this.busy || this.isKeyDown || this.pending) {
            if (this.pending) this.pending.callback(null, this.options)
            this.pending = {action, searchQuery, callback}
            return
          }
          this.query = searchQuery
          this.busy = true
          this.error = null
          let url = `/organization/${this.organization.id}/recipient/autocomplete?type=${this.type}&comtype=${this.comtype}`
          if (this.query) url += `&q=${encodeURIComponent(this.query)}`
          //console.log(url)
          axios.get(url)
          .then(response => {
            this.busy = false
            this.options = _.map(response.data, this.mapRecipient)
            callback(null, this.options)
            if (this.pending && !this.isKeyDown) {
              //console.log('call loadOptions', this.pending.searchQuery)
              const pending = this.pending
              this.pending = null
              if (this.keyDownTimerId) clearTimeout(this.keyDownTimerId)
              this.keyDownTimerId = null
              this.loadOptions(pending)
            }
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
            _.toastError(this, this.error)
            callback(null, [])
          })
        }
      },
      onClickAdd() {
        this.query = document.querySelector('#recipients-treeselect input.vue-treeselect__input').value
        let recipients = _.extractRecipients(this.query)
        if (recipients.length > 1) {
          _.each(recipients, recipient => {
            this.recipients.push(this.mapRecipient(recipient))
          })
          this.$refs.treeselect.closeMenu()
        } else {
          setTimeout(() => {
            this.$bvModal.show('add-recipient-modal')
          }, 50)
        }
      },
      onKeyDown(e) {
        // This is the only way we found to catch a user hitting Enter
        // Allows us to open the modal and add a value based on what they typed
        let el = document.querySelector('#recipients-treeselect input.vue-treeselect__input')
        if (!e.target.isSameNode(el)) return

        if (e.keyCode != 13) {
          this.isKeyDown = true
          if (this.keyDownTimerId) clearTimeout(this.keyDownTimerId)
          //console.log('isKeyDown', e.keyCode)
          this.keyDownTimerId = setTimeout(() => {
            this.isKeyDown = false
            this.keyDownTimerId = null
            if (this.pending && !this.busy) {
              //console.log('call onKeyDown', this.pending.searchQuery)
              const pending = this.pending
              this.pending = null
              this.loadOptions(pending)
            }
          }, 250)
          return
        }

        if (el.value) {
          e.stopImmediatePropagation()
          this.onClickAdd()
          return false
        }
      },
      onPaste(e) {
        let el = document.querySelector('#recipients-treeselect input.vue-treeselect__input')
        if (!e.target.isSameNode(el)) return
        this.$refs.treeselect.openMenu()
      },
    },
    mounted() {
      window.recipientsSelect = this
      document.addEventListener('paste', this.onPaste, true)
      if (this.showAdd)
        document.addEventListener('keydown', this.onKeyDown, true)
    },
    destroyed() {
      document.removeEventListener('paste', this.onPaste, true)
      if (this.showAdd)
        document.removeEventListener('keydown', this.onKeyDown, true)
    },
  }
</script>